module.exports = __webpack_public_path__ + "img/best-conditions-dudes.fd08781b.svg";